<template>
  <div
          class="app hstack"
          @dragover="onDragOver"
          @dragend="onDragEnd"
          @dragexit="onDragEnd"
          @dragleave="onDragEnd"
          @drop="onDrop"
  >
    <sea-modal
            xclass="panel -left panel-settings"
            :active="mode === 'settings'"
            :title="l.settings.title"
            @close="mode = ''"
    >
      <app-settings></app-settings>
    </sea-modal>

    <sea-modal
            xclass="panel -left panel-settings"
            :active="mode === 'remotesettings'"
            title="远程音视频设置"
            @close="state.isPC ? mode = 'doc' : mode = ''"
    >
      <app-remote-settings></app-remote-settings>
    </sea-modal>

    <div
            class="-fit vstack"
            :data-mode="state.maximized ? 'maximized' : 'default'"
            id="video-container"
    >
      <div class="-fit stack videos -relative"  id="video-container-true">
        <app-video
                v-show="videoAllowed && state.stream"
                :stream="state.stream"
                muted
                :mirrored="state.deviceVideo !== 'desktop' && false"
                title="Local"
                id="self"
        />

        <app-video
                v-for="peer in peers"
                :key="peer.remote"
                :id="peer.remote"
                :stream="peer && peer.peer && peer.peer.stream"
                :fingerprint="peer && peer.peer && peer.peer.fingerprint"
                :name="peer && peer.peer && peer.peer.name"
        />

        <div
                class="message-container -error"
                v-if="!state.screenshots && state.requestBugTracking"
        >
          <div class="message">
            发生错误,是否发送错误报告
            <u @click="doAllow(true)">是</u> |
            <u @click="doAllow(false)">否</u>
          </div>
        </div>

        <div class="message-container -error" v-else-if="state.error">
          <div class="message">
            {{ state.error }}
            <u @click="doReload">重载</u>
          </div>
        </div>

        <div class="message-container" v-else-if="state.upgrade">
          <div class="message">
            页面内容已发布新版本,点击重载更新
            <u @click="doReload">重载</u>
          </div>
        </div>

        <div
                class="message-container"
                v-else-if="
            !hasPeers &&
            !state.screenshots &&
            mode !== 'share' &&
            state.showInviteHint
          "
        >
          <div
                  class="message"
                  v-html="l.share.message.replace('$symbol$', symbol)"
          ></div>
        </div>
      </div>

      <div class="tools hstack">
        <sea-link
                v-if="state.showSettings"
                @action="doTogglePanel('settings')"
                class="tool"
                :class="{ '-active': mode === 'settings' }"
        >
          <!--        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>-->
          <!--<svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="4" y1="21" x2="4" y2="14"></line>
            <line x1="4" y1="10" x2="4" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12" y2="3"></line>
            <line x1="20" y1="21" x2="20" y2="16"></line>
            <line x1="20" y1="12" x2="20" y2="3"></line>
            <line x1="1" y1="14" x2="7" y2="14"></line>
            <line x1="9" y1="8" x2="15" y2="8"></line>
            <line x1="17" y1="16" x2="23" y2="16"></line>
          </svg>
          -->
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 1024 1024"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
          >
            <path d="M868.355 291.969l-95.558-15.726-29.174-72.070c-16.743-41.3-56.578-67.992-101.478-67.992l-260.384 0c-44.855 0-84.709 26.682-101.565 68.042l-29.128 72.019-95.517 15.726c-53.023 8.687-91.504 53.659-91.504 106.941v385.782c0 59.772 49.065 108.406 109.372 108.406h677.035c60.322 0 109.403-48.623 109.403-108.396v-385.792c0-53.282-38.481-98.254-91.499-106.941zM897.356 784.703c0 25.308-21.036 45.897-46.904 45.897h-677.035c-25.848 0-46.874-20.599-46.874-45.908l0-385.782c0-22.512 16.449-41.553 39.132-45.267l112.856-18.584c10.752-1.77 19.805-9.012 23.894-19.113l35.68-88.214c7.192-17.649 24.327-29.052 43.654-29.052h260.384c19.327 0 36.427 11.373 43.558 28.961l35.755 88.315c4.079 10.091 13.132 17.334 23.884 19.103l112.882 18.584c0.010 0 0.020 0 0.020 0.010 22.664 3.702 39.112 22.745 39.112 45.257l0 385.793z" p-id="12452" fill="#ffffff"></path><path d="M436.876 473.188c-17.257 0-31.249 13.987-31.249 31.249v30.486c0 17.262 13.992 31.249 31.249 31.249s31.249-13.987 31.249-31.249v-30.486c0-17.261-13.992-31.249-31.249-31.249z" p-id="12453" fill="#ffffff"></path><path d="M587.024 473.188c-17.262 0-31.249 13.987-31.249 31.249v30.486c0 17.262 13.987 31.249 31.249 31.249s31.249-13.987 31.249-31.249v-30.486c0-17.261-13.987-31.249-31.249-31.249z" p-id="12454" fill="#ffffff"></path><path d="M768.412 403.814c-12.207-12.207-31.981-12.207-44.188 0l-19.261 19.262c-39.232-69.398-114.001-114.87-195.852-114.87-98.691 0-187.276 66.007-215.417 160.518-4.923 16.54 4.496 33.945 21.036 38.868 16.57 4.923 33.945-4.496 38.868-21.026 20.309-68.215 84.257-115.862 155.513-115.862s135.209 47.647 155.523 115.862c0.162 0.541 0.418 1.025 0.605 1.551 0.261 0.734 0.529 1.455 0.847 2.171 0.521 1.178 1.126 2.287 1.775 3.371 0.309 0.516 0.577 1.044 0.919 1.544 1.101 1.619 2.316 3.135 3.678 4.499 0.011 0.011 0.017 0.025 0.030 0.036 0.071 0.071 0.156 0.115 0.226 0.185 1.284 1.258 2.68 2.377 4.151 3.39 0.533 0.368 1.083 0.68 1.632 1.012 1.070 0.645 2.165 1.226 3.304 1.74 0.627 0.281 1.249 0.557 1.891 0.796 1.224 0.457 2.478 0.811 3.757 1.114 0.525 0.123 1.035 0.289 1.564 0.384 1.824 0.333 3.676 0.544 5.561 0.544 1.77 0 3.56-0.208 5.352-0.523 0.558-0.096 1.102-0.238 1.655-0.365 0.643-0.148 1.283-0.234 1.925-0.425 0.45-0.134 0.837-0.371 1.277-0.525 1.057-0.365 2.081-0.793 3.102-1.274 0.917-0.432 1.804-0.889 2.662-1.401 0.837-0.5 1.64-1.048 2.438-1.634 0.927-0.679 1.807-1.391 2.645-2.161 0.338-0.31 0.723-0.531 1.050-0.858l51.736-51.736c12.205-12.197 12.205-31.993-0.002-44.188z" p-id="12455" fill="#ffffff"></path><path d="M709.159 558.289c-16.519-4.923-33.935 4.496-38.858 21.036-20.303 68.215-84.257 115.852-155.513 115.852-71.262 0-135.215-47.647-155.518-115.852-0.135-0.455-0.376-0.845-0.53-1.29-0.363-1.053-0.79-2.076-1.27-3.093-0.432-0.919-0.89-1.805-1.403-2.665-0.498-0.834-1.044-1.633-1.626-2.428-0.685-0.936-1.404-1.824-2.182-2.669-0.306-0.334-0.525-0.715-0.848-1.039-0.328-0.33-0.717-0.553-1.057-0.864-0.847-0.775-1.724-1.489-2.647-2.163-0.781-0.573-1.566-1.112-2.384-1.604-0.879-0.526-1.78-0.989-2.706-1.425-0.919-0.434-1.835-0.84-2.783-1.179-0.939-0.337-1.891-0.602-2.862-0.848-0.976-0.247-1.943-0.468-2.934-0.619-0.992-0.152-1.985-0.231-2.994-0.288-1.029-0.056-2.046-0.080-3.076-0.036-0.953 0.041-1.898 0.142-2.856 0.273-1.129 0.153-2.237 0.363-3.346 0.639-0.454 0.114-0.909 0.125-1.362 0.26-0.444 0.132-0.825 0.366-1.258 0.517-1.073 0.37-2.116 0.804-3.152 1.296-0.898 0.425-1.768 0.873-2.609 1.374-0.852 0.508-1.669 1.064-2.479 1.661-0.918 0.674-1.79 1.379-2.622 2.143-0.34 0.311-0.729 0.535-1.057 0.864l-51.736 51.736c-12.207 12.197-12.207 31.992 0 44.188 6.098 6.103 14.099 9.156 22.094 9.156s15.996-3.051 22.094-9.156l19.26-19.26c39.234 69.4 114.004 114.869 195.853 114.869 98.701 0 187.281-66.007 215.408-160.528 4.92-16.54-4.499-33.935-21.039-38.858z" p-id="12456" fill="#ffffff"></path>
          </svg>
        </sea-link>
        <sea-link
                v-if="state.showLoc && state.isPC"
                @action="getGeoInfo()"
                class="tool"
                v-preventReClick
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 368 368"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
          >
            <path d="M184.333,0C102.01,0,35.036,66.974,35.036,149.297c0,33.969,11.132,65.96,32.193,92.515
				c27.27,34.383,106.572,116.021,109.934,119.479l7.169,7.375l7.17-7.374c3.364-3.46,82.69-85.116,109.964-119.51
				c21.042-26.534,32.164-58.514,32.164-92.485C333.63,66.974,266.656,0,184.333,0z M285.795,229.355
				c-21.956,27.687-80.92,89.278-101.462,110.581c-20.54-21.302-79.483-82.875-101.434-110.552
				c-18.228-22.984-27.863-50.677-27.863-80.087C55.036,78.002,113.038,20,184.333,20c71.294,0,129.297,58.002,129.296,129.297
				C313.629,178.709,304.004,206.393,285.795,229.355z" fill="#ffffff"/>
            <path d="M184.333,59.265c-48.73,0-88.374,39.644-88.374,88.374c0,48.73,39.645,88.374,88.374,88.374s88.374-39.645,88.374-88.374
				S233.063,59.265,184.333,59.265z M184.333,216.013c-37.702,0-68.374-30.673-68.374-68.374c0-37.702,30.673-68.374,68.374-68.374
				s68.373,30.673,68.374,68.374C252.707,185.341,222.035,216.013,184.333,216.013z" fill="#ffffff"/>
          </svg>
        </sea-link>
        <div class="-fit">
          <sea-link
                  class="tool"
                  :class="{ '-off': state.muteVideo }"
                  @action="doVideo"
                  v-if="state.isPC"
          >
            <svg
                    v-if="state.muteVideo"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
            >
              <path
                      d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
              ></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
            <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
            >
              <polygon points="23 7 16 12 23 17 23 7"></polygon>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
            </svg>
          </sea-link>
          <sea-link class="tool tool-close" @action="doQuit" v-if="state.isPC">
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            <!--          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line></svg>-->
          </sea-link>
          <sea-link
                  class="tool"
                  :class="{ '-off': state.muteAudio }"
                  @action="doAudio"
                  v-if="state.isPC"
          >
            <svg
                    v-if="state.muteAudio"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
            >
              <line x1="1" y1="1" x2="23" y2="23"></line>
              <path
                      d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
              ></path>
              <path
                      d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
              ></path>
              <line x1="12" y1="19" x2="12" y2="23"></line>
              <line x1="8" y1="23" x2="16" y2="23"></line>
            </svg>
            <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
            >
              <path
                      d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
              ></path>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
              <line x1="12" y1="19" x2="12" y2="23"></line>
              <line x1="8" y1="23" x2="16" y2="23"></line>
            </svg>
          </sea-link>
        </div>
        <sea-link
                v-if="state.showFullscreen && supportsFullscreen"
                @action="doToggleFullScreen"
                class="tool"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  v-if="!isFullScreen"
          >
            <path
                    d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
            ></path>
          </svg>
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  v-if="isFullScreen"
          >
            <path
                    d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
            ></path>
          </svg>
        </sea-link>

        <sea-link
                v-if="state.showChat && state.isPC && !state.client"
                @action="toggleChat()"
                class="tool messageBtn"
                :class="{ '-active': mode === 'chat' }"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-message-square"
          >
            <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            ></path>
          </svg>
          <div v-if="unreadMessages" class="unread-msg"></div>
        </sea-link>

        <sea-link
                v-if="state.isPC && state.showShare && !state.client"
                @action="doTogglePanel('share')"
                class="tool"
                :class="{ '-active': mode === 'share' }"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
          >
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
            <polyline points="16 6 12 2 8 6"></polyline>
            <line x1="12" y1="2" x2="12" y2="15"></line>
          </svg>
        </sea-link>

        <sea-link
                v-if="state.isPC && !state.client"
                @action="doToggleCropTool"
                class="tool"
                :class="{ '-active': state.showCropTool === true }"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 489 489"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
          >
            <polygon points="336.2,489.4 391.4,489.4 391.4,98 0,98 0,153.2 336.2,153.2" style="fill:#ffffff;"/>
            <rect x="90.6" y="0.4" width="55.2" height="68" style="fill:#ffffff;"/>
            <polygon points="306.7,352.2 138,352.2 138,183.1 82.8,183.1 82.8,407.4 306.7,407.4" style="fill:#ffffff;"/>
            <rect x="421.4" y="344.4" width="68.4" height="55.2" style="fill:#ffffff;"/>
          </svg>
        </sea-link>

        <sea-link
                v-if="state.isPC && state.showRec && !state.client"
                @action="doToggleRecord"
                class="tool"
                :class="{ '-active': state.onAir === true }"
                v-preventReClick
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"

                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :stroke="onAir"
          >
            <!-- fill="none" stroke="currentColor"-->
            <path d="m7.3293,8.91883c0.85422,0 1.62755,0.34622 2.18732,0.90599c0.55977,0.55977 0.90599,1.3331 0.90599,2.18732c0,0.73288 -0.25562,1.4059 -0.68111,1.93655l4.61569,0c-0.42549,-0.53065 -0.68111,-1.20367 -0.68111,-1.93655c0,-0.85422 0.34622,-1.62755 0.90599,-2.18732c0.55977,-0.55977 1.3331,-0.90599 2.18732,-0.90599c0.85422,0 1.62755,0.34622 2.18732,0.90599c0.55977,0.55977 0.90599,1.3331 0.90599,2.18732c0,0.85422 -0.34622,1.62755 -0.90599,2.18732c-0.55977,0.55977 -1.3331,0.90599 -2.18732,0.90599l-9.23139,0c-0.02103,0 -0.04206,-0.00162 -0.0631,-0.00324c-0.04854,0.00162 -0.09545,0.00324 -0.14399,0.00324c-0.85422,0 -1.62755,-0.34622 -2.18732,-0.90599c-0.55977,-0.55977 -0.90599,-1.3331 -0.90599,-2.18732c0,-0.85422 0.34622,-1.62755 0.90599,-2.18732c0.55815,-0.55977 1.33148,-0.90599 2.1857,-0.90599l0,0zm-2.66296,-6.78845l14.66733,0c0.7167,0 1.36869,0.29283 1.8411,0.76524c0.47241,0.47241 0.76524,1.1244 0.76524,1.8411l0,14.52658c0,0.7167 -0.29283,1.36869 -0.76524,1.8411c-0.47241,0.47241 -1.1244,0.76524 -1.8411,0.76524l-14.66733,0c-0.7167,0 -1.36869,-0.29283 -1.8411,-0.76524c-0.47241,-0.47241 -0.76524,-1.1244 -0.76524,-1.8411l0,-14.52658c0,-0.7167 0.29283,-1.36869 0.76524,-1.8411c0.47241,-0.47241 1.12278,-0.76524 1.8411,-0.76524l0,0zm14.66733,1.15837l-14.66733,0c-0.39799,0 -0.75877,0.1634 -1.02247,0.42549c-0.26209,0.26209 -0.42549,0.62449 -0.42549,1.02247l0,14.52658c0,0.39799 0.1634,0.75877 0.42549,1.02247c0.26209,0.26209 0.62449,0.42549 1.02247,0.42549l14.66733,0c0.39799,0 0.75877,-0.1634 1.02247,-0.42549c0.26209,-0.26209 0.42549,-0.62449 0.42549,-1.02247l0,-14.52658c0,-0.39799 -0.1634,-0.75877 -0.42549,-1.02247c-0.26209,-0.26209 -0.62449,-0.42549 -1.02247,-0.42549l0,0zm-1.19235,7.3547c-0.35107,-0.35107 -0.8348,-0.56786 -1.36869,-0.56786c-0.5355,0 -1.01924,0.21679 -1.36869,0.56786c-0.35107,0.35107 -0.56786,0.8348 -0.56786,1.36869c0,0.5355 0.21679,1.01924 0.56786,1.36869c0.35107,0.35107 0.8348,0.56786 1.36869,0.56786c0.5355,0 1.01924,-0.21679 1.36869,-0.56786c0.35107,-0.35107 0.56786,-0.8348 0.56786,-1.36869c0,-0.53389 -0.21679,-1.01762 -0.56786,-1.36869l0,0zm-9.44171,0c-0.35107,-0.35107 -0.8348,-0.56786 -1.36869,-0.56786c-0.5355,0 -1.01924,0.21679 -1.36869,0.56786c-0.35107,0.35107 -0.56786,0.8348 -0.56786,1.36869c0,0.5355 0.21679,1.01924 0.56786,1.36869c0.35107,0.35107 0.8348,0.56786 1.36869,0.56786c0.5355,0 1.01924,-0.21679 1.36869,-0.56786c0.35107,-0.35107 0.56786,-0.8348 0.56786,-1.36869c-0.00162,-0.53389 -0.21841,-1.01762 -0.56786,-1.36869l0,0z"/>
          </svg>
        </sea-link>

        <sea-link
                v-if="state.isPC && (state.showDoc || state.mandShowDoc) && !state.client"
                @action="doDocCenter"
                class="tool"
                :class="{ '-active': mode === 'doc' }"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
          >
            <path d="m19.94026,7.83626a1.34766,1.34766 0 0 0 -0.42346,-0.55549l-5.08955,-4.95914a0.56837,0.56837 0 0 0 -0.44439,-0.21253l-8.8878,0a1.03369,1.03369 0 0 0 -1.0353,1.0353l0,17.7112a1.03369,1.03369 0 0 0 1.0353,1.0353l13.81151,0a1.03369,1.03369 0 0 0 1.03047,-1.0353l0,-8.54324l0,0l0,-4.4761l0.00322,0zm-5.38259,-3.70325l3.45851,3.23954l-3.45851,0l0,-3.23954zm-2.48762,16.60505l-6.85423,0l0,-17.47773l8.18257,0l0,4.68703a0.58125,0.58125 0 0 0 0.58125,0.58125l4.80456,0l0,3.78376l0,0l0,8.4257l-6.71415,0zm-4.7144,-10.09538a0.41541,0.41541 0 0 1 0.30109,-0.14169l6.79305,0a0.41058,0.41058 0 0 1 0.30753,0.14008a0.48303,0.48303 0 0 1 0.12237,0.32202a0.49591,0.49591 0 0 1 -0.12398,0.32202a0.4138,0.4138 0 0 1 -0.30592,0.14169l-6.78822,0a0.41219,0.41219 0 0 1 -0.30753,-0.14008a0.49913,0.49913 0 0 1 0,-0.65692l0.00161,0.01288zm0,6.56441a0.40736,0.40736 0 0 1 0.30592,-0.14169l8.67527,0a0.41058,0.41058 0 0 1 0.30753,0.14169a0.49913,0.49913 0 0 1 0,0.65692a0.41702,0.41702 0 0 1 -0.30914,0.13847l-8.67366,0a0.41702,0.41702 0 0 1 -0.30753,-0.13847a0.49913,0.49913 0 0 1 0,-0.65692l0.00161,0zm8.98119,-3.42148a0.41702,0.41702 0 0 1 0.30753,0.14169a0.49913,0.49913 0 0 1 0,0.65692a0.4138,0.4138 0 0 1 -0.30914,0.14008l-8.67366,0a0.41219,0.41219 0 0 1 -0.30753,-0.14008a0.49913,0.49913 0 0 1 0,-0.65692a0.4138,0.4138 0 0 1 0.30592,-0.14169l8.67688,0zm-8.98119,-6.42272a0.4138,0.4138 0 0 1 0.30592,-0.14169l3.1381,0a0.41219,0.41219 0 0 1 0.30753,0.14008a0.48303,0.48303 0 0 1 0.12237,0.32202a0.4943,0.4943 0 0 1 -0.12076,0.32202l0,0a0.41541,0.41541 0 0 1 -0.30592,0.14169l-3.14132,0a0.41219,0.41219 0 0 1 -0.30753,-0.14008a0.49913,0.49913 0 0 1 0,-0.65692l0.00161,0.01288z"/>
          </svg>
        </sea-link>
      </div>
      <app-tool v-if="state.isPC && !state.client"></app-tool>
    </div>

    <sea-modal
            xclass="panel -left panel-share"
            :active="mode === 'share'"
            :title="l.share.title"
            @close="state.isPC ? mode = 'doc' : mode = ''"
            ref="shareContainer"
    >
      <app-share></app-share>
    </sea-modal>

    <sea-modal
            xclass="panel -left panel-share"
            :active="mode === 'chat'"
            :title="l.chat.title"
            @close="state.isPC ? mode = 'doc' : mode = ''"
            :scrollable="false"
            ref="chatContainer"
    >
      <app-chat :name="this.name"></app-chat>
    </sea-modal>

    <sea-modal
            xclass="panel -left panel-doc"
            :active="mode === 'doc'"
            title=""
            :close="false"
            @close="state.isPC ? mode = 'doc' : mode = ''"
            ref="docContainer"
    >
      <app-doc></app-doc>
    </sea-modal>

    <sea-modal
            xclass="panel -left panel-ocr"
            :active="mode === 'ocr'"
            title=""
            :close="false"
            @close="state.isPC ? mode = 'doc' : mode = ''"
            ref="ocrContainer"
    >
      <app-ocr></app-ocr>
    </sea-modal>

    <sea-modal
            xclass="panel -left panel-page"
            :active="mode === 'page'"
            title=""
            :close="false"
            @close="state.isPC ? mode = 'doc' : mode = ''"
            ref="pageContainer"
    >
      <app-page></app-page>
    </sea-modal>
  </div>
</template>

<style>
  .vl-notify, .vl-notify-main, .vl-notify-alert, .vl-notify-alert {
    color: #2f2725;
  }
</style>

<script>
  import { messages } from "../lib/emitter"
  import { createLinkForRoom, shareLink } from "../lib/share"
  import { setup } from "../state"
  import SeaButton from "../ui/sea-button"
  import SeaLink from "../ui/sea-link"
  import SeaModal from "../ui/sea-modal"
  import AppVideo from "./app-video"
  import { setAllowedBugTracking } from "../bugs"
  import { setBackgroundImage } from "../logic/background"
  import OBSWebSocket from 'obs-websocket-js'

  import { Logger } from "../lib/logger"
  const log = Logger("app:app-sidebar")

  export default {
    name: "app-main",
    components: {
      AppSettings: () =>
              import(/* webpackChunkName: 'settings' */ "./app-settings"),
      AppShare: () => import(/* webpackChunkName: 'share' */ "./app-share"),
      AppChat: () => import(/* webpackChunkName: 'chat' */ "./app-chat"),
      AppDoc: () => import(/* webpackChunkName: 'doc' */ "./app-doc"),
      AppOcr: () => import(/* webpackChunkName: 'ocr' */ "./app-ocr"),
      AppPage: () => import(/* webpackChunkName: 'page' */ "./app-page"),
      AppTool: () => import(/* webpackChunkName: 'tool' */ "./app-tool"),
      AppRemoteSettings: () =>
              import(/* webpackChunkName: 'remotesettings' */ "./app-remote-settings"),
      SeaLink,
      SeaModal,
      SeaButton,
      AppVideo,
    },
    data() {
      return {
        timeout : 3600000,
        timer:null,
        timer1:null,
        mode: "",
        settings: false,
        share: false,
        conn: null,
        dragOver: false,
        supportsFullscreen: document.fullscreenEnabled,
        isFullScreen: false,
        fullscreenHandler: null,
        symbol:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></svg>',
        name: "",
        unreadMessages: false,
        obs: new OBSWebSocket(),
        continueRecord: '',
        heartbeatWs: null,
        heartbeatTimer: null,
        curVideo:{}
      }
    },
    computed: {
      hasPeers() {
        return Object.keys(this.state.status).length > 0
      },
      peers() {
        return this.state.screenshots ? [2, 3] : this.state.status
      },
      videoAllowed() {
        if (window.webkit != null) {
          return this.mode === ""
        }
        return true
      },
      onAir() {
        return this.state.onAir === true ? "red" : "currentColor"
      }
    },
    methods: {
      doShare() {
        shareLink(createLinkForRoom(this.state.room))
      },
      doVideo() {
        this.state.muteVideo = !this.state.muteVideo
        messages.emit("updateStream")
      },
      doAudio() {
        this.state.muteAudio = !this.state.muteAudio
        messages.emit("updateStream")
      },
      doQuit() {
        if (confirm(this.l.common.quit)) {
          //location.assign("/room/")
          this.state.onAir = false
          this.obs.call('StopStream')

          let name = this.nameString
          let current = new Date()
          let ampm = current.getHours() < 12 ? "AM" : "PM"
          let time =
                  current.getHours() +
                  ":" +
                  current.getMinutes() +
                  ":" +
                  current.getSeconds() +
                  " " +
                  ampm
          let message = 'sys|endchat|相关处理结束,请关闭退出'
          let tips = ""
          let is_cmd = message.startsWith('sys|')
          messages.emit("chatMessage", { name, message, time, is_cmd, tips })

          setTimeout(() => {
            window.opener = null
            window.open(' ', '_self')
            window.close()
          }, 2000)
        }
      },
      doReload() {
        location.reload()
      },
      doAllow(allow) {
        if (allow) {
          setAllowedBugTracking(allow)
        }
        this.state.requestBugTracking = false
      },
      doToggleFullScreen() {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen()
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          }
        }
      },
      doTogglePanel(mode = "doc") {
        this.mode = !mode || this.mode === mode ? (this.state.isPC ? "doc" : "") : mode //default=doc
      },
      doToggleRecord() {
        messages.emit("ToggleRecord", -1)
      },
      doToggleCropTool() {
        messages.emit("ToggleCropTool", -1)
      },
      onDragOver(ev) {
        ev.preventDefault()
        ev.dataTransfer.dropEffect = "copy"
        this.dragOver = true
      },
      onDragEnd(ev) {
        this.dragOver = false
        ev.preventDefault()
      },
      onDrop(ev) {
        this.dragOver = false
        ev.preventDefault()
        let dataProvider = ev.dataTransfer || ev.clipboardData
        if (dataProvider) {
          const files = dataProvider?.files || []
          if (files.length) {
            let url = URL.createObjectURL(files[0])
            setBackgroundImage(url)
            this.state.backgroundImageURL = url
            this.state.backgroundAuthor = ""
            this.state.backgroundURL = ""

            // If just the background mode changes, don't restart the whole thing
            // if ((value && !prevValue) || (prevValue && !value)) {
            if (this.state.backgroundImageURL !== "image") {
              this.state.backgroundMode = "image"
              messages.emit("switchMedia")
            }
            // }
          }
        }
      },
      didChangeFullscreen(ev) {},
      toggleChat() {
        if (this.mode === "chat") {
          this.mode = this.state.isPC ? "doc" : "" //default=doc
        } else {
          this.unreadMessages = false
          this.mode = "chat"
          this.focusChatInput()
        }
      },
      updateUserInfo() {
        messages.emit("userInfo", {
          name: this.name,
        })
      },
      triggerChatFunctions() {
        messages.on("newMessage", (info) => {
          if (this.mode !== "chat") {
            this.unreadMessages = false
            //this.mode = "chat"
            //this.focusChatInput()
          }
        })

        messages.on("userInfoUpdate", ({ peer, data }) => {
          this.peers[
                  this.peers.findIndex((el) => el.remote === peer.local)
                  ].peer.name = data.data.name
        })

        // Update Local Name to Remote peers every 10 seconds for new peers
        messages.on("requestUserInfo", () => {
          this.updateUserInfo()
        })

        messages.on("switchMode", (mode) => {
          this.initWidth()
          this.mode = mode
        })

        messages.on("changeVideoLayout", () => {
          //console.log("onChangeVideoLayout")
          this.state.maximized = this.peers[0]?.remote ?? "self"
        })

        messages.on("layerMsg", (msg) => {
          this.$layer.msg(msg, {
            time: 3,
          })
        })

        messages.on("layerAlert", (msg) => {
          this.$layer.alert(msg,{
                    title: '提示'
                  },layerid => {
                    this.$layer.close(layerid)
                  }
          )
        })

        messages.on("layerTips", (msg) => {
          this.$layer.tips(msg, '#video-container', {
            tips: 0,
            time: 4
          })
        })

        messages.on("layerLoading", () => {
          this.$layer.loading({time: 3, content:'请稍候...'})
        })

        messages.on("onRequestLoc", (param) => {
          !this.state.client || this.getGeoInfo()
        })

        messages.on("requestUserDevice", (param) => {
          !this.state.client || this.requestUserDevice(param)
        })

        messages.on("reportUserDevice", (devices) => {
          this.reportUserDevice(devices)
        })

        messages.on("setUserDevice", (param) => {
          this.setUserDevice(param)
        })

        messages.on("endChat", (msg) => {
          this.$layer.alert(msg, {
                    title: '提示'
                  },layerid => {
                    this.$layer.close(layerid)
                    //关闭小程序
                  }
          )
        })

        messages.on("videoCreated", (video) => {
          console.log("=========== videoCreated =========")
          if(this.state.videoWallCanvas && this.state.audioContext) {
            setTimeout(() => {
              this.streaming()
            }, 1000)
          }
        })

        messages.on("videoMounted", (stream, video) => {
          console.log("=========== videoMounted =========", stream, video)
        })

      },
      async streaming() {
        await this.$nextTick()

        const video_container = document.getElementById('video-container-true')
        const video_list = video_container.getElementsByTagName('video')

        console.log("== video_list.length ==", video_list.length)

        if (video_list.length < 2) {
          console.log("视频路数不足，跳过推流录像")
          return
        }

        if (!this.state.pushPeer) {
          console.log("初次推流开始...")
          this.drawVideoWall()

          this.state.pushPeer = new RTCPeerConnection()

          const stream4canvas = this.state.videoWallCanvas.captureStream(20)
          stream4canvas.getVideoTracks().forEach((track) => {
            this.state.pushPeer.addTrack(track, stream4canvas)
          })

          const audioDestination = this.state.audioContext.createMediaStreamDestination()

          for (let i = 0; i < video_list.length; i++) {
            const video = video_list.item(i)
            const s = video.captureStream()
            const audio = this.state.audioContext.createMediaStreamSource(s)
            // const audio = this.state.audioContext.createMediaElementSource(video_list.item(i))
            audio.connect(audioDestination)
          }

          audioDestination.stream.getAudioTracks().forEach((track) => {
            this.state.pushPeer.addTrack(track, audioDestination.stream)
          })

          const offer = await this.state.pushPeer.createOffer()
          await this.state.pushPeer.setLocalDescription(offer)

          const zlmApiUrl = (this.state.streamserver !== "" ? this.state.streamserver : "http://127.0.0.1:9092") + '/index/api/webrtc?app=case&stream=' + this.state.caseid + '&type=push&secret=' + '035c73f7-bb6b-4889-a715-d9eb2d1925cd'
          console.log("===zlmApiUrl==",zlmApiUrl)
          await fetch(zlmApiUrl, {
            method: 'POST',
            body: offer.sdp
          }).then(response => {
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
              })
              .then(body => {
                console.log("==zlm api reponse get answer==", body);

                if (body.code === 0) {
                  const remoteSdp = body.sdp;
                  return this.state.pushPeer.setRemoteDescription(
                      new RTCSessionDescription({type: 'answer', sdp: remoteSdp})
                  ).then(() => {
                    this.state.showDoc=true;
                    this.state.onAir = true;
                  });
                } else {
                  throw new Error(`API error: ${body.message || 'Unknown error'}`);
                }
              })
              .catch(error => {
                alert("录像不正常，不能制作文书，请更换可以录像的浏览器或者联系管理员！")
                this.state.showDoc=false;
                console.error("Error:", error);
              });

          // const response = await fetch(zlmApiUrl, { method: 'POST', body: offer.sdp })
          //
          // const body = await response.json()
          //  console.log("==zlm api reponse get answer==", body)
          // if(body.code === 0) {
          //   const remoteSdp = body.sdp
          //   await this.state.pushPeer.setRemoteDescription(
          //           new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }),
          //   )
          //
          //   this.state.onAir = true
          // }

        } else {
          console.log("新增会话，获取音轨加入推流...")
          try {
            const audioDestination = this.state.audioContext.createMediaStreamDestination()
            for (let i = 0; i < video_list.length; i++) {
              const video = video_list.item(i)

              const s = video.captureStream()
              const audio = this.state.audioContext.createMediaStreamSource(s)

              //MediaElementSource
              // const audio = this.state.audioContext.createMediaElementSource(video)

              audio.connect(audioDestination)
            }

            audioDestination.stream.getAudioTracks().forEach((track) => {
              // this.state.pushPeer.addTrack(track, this.state.audioDestination.stream)
              this.state.pushPeer.getSenders().forEach((sender) => {
                if (sender.track.kind === 'audio') {
                  sender.replaceTrack(track)
                      .then(() => {
                        console.log('Audio track replaced successfully')
                      })
                      .catch(error => {
                        console.error('Error replacing audio track:', error)
                      })
                }
              })
            })

          } catch (e) {
            console.log("err", e)
          }
        }
      },
      dateformatter(date, format) {
        var o = {
            "M+": date.getMonth() + 1, //month
            "d+": date.getDate(), //day
            "H+": date.getHours(), //hour
            "m+": date.getMinutes(), //minute
            "s+": date.getSeconds(), //second
            "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
            "S": date.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1,(date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) if (new RegExp("(" + k + ")").test(format))format = format.replace(RegExp.$1,RegExp.$1.length == 1 ? o[k] :("00" + o[k]).substr(("" + o[k]).length));
        return format;
      },
      async drawVideoWall() {
        const video_container = document.getElementById('video-container-true');
        const video_list = video_container.getElementsByTagName('video');
        const ctx = this.state.videoWallCanvas.getContext('2d')

        const drawType = 1

        if(drawType === 0) {
          //2*2矩阵
          const split = 2
          const width = this.state.videoWallCanvas.width / split
          const height = this.state.videoWallCanvas.height / split
          const canvasRatio = width / height

          for(let i = 0; i < video_list.length; i++) {
            const video = video_list.item(i)
            //draw
            let x = (i % split) * width
            let y = 0
            if(i >= split) {
              y = height
            }

            const videoRatio = video.videoWidth / video.videoHeight
            let dw, dh
            if(videoRatio <= canvasRatio) {
              dw = videoRatio * height
              dh = height
            }else {
              dw = width
              dh = width / videoRatio
            }

            ctx.drawImage(video, x, y, dw, dh)
          }
        }else {
          // if(this.state.videoWallCanvas.width !== video_container.offsetWidth) {
          //   console.log("canvas width changed: " + this.state.videoWallCanvas.width + " -> " + video_container.offsetWidth)
          //   this.state.videoWallCanvas.setAttribute("width", video_container.offsetWidth)
          // }
          //
          // if(this.state.videoWallCanvas.height !== video_container.offsetHeight) {
          //   console.log("canvas height changed: " + this.state.videoWallCanvas.height + " -> " + video_container.offsetHeight)
          //   this.state.videoWallCanvas.setAttribute("height", video_container.offsetHeight)
          // }

            const width = this.state.videoWallCanvas.width
            const height = this.state.videoWallCanvas.height
            const canvasRatio = width / height

            const videoRatio =  video_container.offsetWidth / video_container.offsetHeight
            //console.log(" video_container width height=", video_container.offsetWidth,video_container.offsetHeight," canvasRatio=" ,canvasRatio ,"videoRatio=",videoRatio)

            let dw, dh
            if(videoRatio <= canvasRatio) {
              dw = videoRatio * height
              dh = height
            }else {
              dw = width
              dh = width / videoRatio
            }
            // const calcRatio=width /dw
            const calcRatio=dw /video_container.offsetWidth
            const canvasLeft = (width-dw) /2
            const canvasTop= (height-dh)/2
           // console.log(" canvas width height=",width,height," calc w h=",dw,dh," calcRatio=",calcRatio,"canvasLeft=",canvasLeft,"canvasTop=",canvasTop)

            //  console.log("==canvasRatio==",canvasRatio,"==calcRatio=",dw/dh ,"==videoRatio==",videoRatio,dw,dh,width,height)

            if ( this.curVideo.w==undefined || this.curVideo.w!= video_container.offsetWidth || this.curVideo.h!=video_container.offsetHeight) {
              this.curVideo.w=video_container.offsetWidth  ;
              this.curVideo.h=video_container.offsetHeight;
            }

          ctx.clearRect(0,0,width,height);

          for(let i = 0; i < video_list.length; i++) {
            const video = video_list.item(i)
            const videoClient = video.getBoundingClientRect()

           const  dx= this.calcVideoXY(video);
            //console.log("==dx==",dx,video.videoWidth,video.videoHeight,calcRatio,"video_container.offsetLeft=",video_container.offsetLeft)

            const x = (videoClient.x -video_container.offsetLeft +dx.x)  *calcRatio+canvasLeft
            const y = (videoClient.y-video_container.offsetTop+dx.y) *calcRatio+canvasTop

            const width1 = dx.w*calcRatio
            const height1 = dx.h *calcRatio

            ctx.drawImage(video, x, y, width1, height1)
          }

          const current = new Date();
          const caption = this.state.caseid + " " + this.dateformatter(current, "yyyy-MM-dd HH:mm:ss");
          ctx.font = "24px 宋体";
          ctx.textAlign = 'left';
          ctx.fillStyle = "yellow";
          ctx.fillText(caption, 20, 20);
        }

        requestAnimationFrame(this.drawVideoWall)
      },
      calcVideoXY(video){
        const videoClient = video.getBoundingClientRect()

        const videoWidth=video.videoWidth;
        const videoHeight=video.videoHeight;
        const videoRatio=videoWidth/videoHeight;

        const parentRatio= videoClient.width/videoClient.height;

       // console.log("videoRatio==",videoRatio,"parentRatio=",parentRatio,"videoClient.width=",videoClient.width,"videoClient.height=",videoClient.height)
        let x,y,w,h=0
        if(videoRatio <= parentRatio) {
          x= (videoClient.width- videoClient.height*videoRatio )/2
          y=0
          h=videoClient.height
          w= Math.round(videoClient.height*videoRatio)
          //console.log("w1==",w)
        }else {
           x=0
           y= (videoClient.height-  videoClient.width/videoRatio)/2
           w=videoClient.width
           h= Math.round(videoClient.width/videoRatio)
          //console.log("h1==",h)

        }
        return {x,y,w,h}
      },
      requestUserDevice(param) {
        //console.log("requestUserDevice", param)
        if(!this.state.client) {
          return
        }

        if(!this.peers || this?.peers.length < 1) {
          return
        }

        if(this.peers[0]?.local !== param) {
          console.log("not me, ignore")
          return
        }

        let payload = {
          peer: param,
          devices: this.state.devices
        }

        let message = "sys|reportUserDevice|" + JSON.stringify(payload)
        let name = this.nameString || ""
        let current = new Date()
        let ampm = current.getHours() < 12 ? "AM" : "PM"
        let time =
                current.getHours() +
                ":" +
                current.getMinutes() +
                ":" +
                current.getSeconds() +
                " " +
                ampm
        let tips = ""
        let is_cmd = true

        messages.emit("chatMessage", { name, message, time, is_cmd, tips })
      },
      reportUserDevice(payload) {
        //console.log("reportUserDevice", payload)
        //this.$layer.closeAll()
        if(!this.state.client) {
          let d = JSON.parse(payload)
          if(d && d.hasOwnProperty("devices")) {
            this.state.remotePeer = d.peer
            this.state.remoteDevices = d.devices
            // this.state.remoteDeviceVideo = null
            // this.state.remoteDeviceAudio = null
            messages.emit("switchMode", "remotesettings")
          }
        }
      },
      setUserDevice(param) {
        console.log("ars setUserDevice", param)
        if(!this.state.client) {
          let payload = {
            peer: this.state.remotePeer,
            device_type: param,
            deviceId: param == "video" ? this.state.remoteDeviceVideo : this.state.remoteDeviceAudio
          }
          let message = "sys|setUserDevice|" + JSON.stringify(payload)
          let name = this.nameString || ""
          let current = new Date()
          let ampm = current.getHours() < 12 ? "AM" : "PM"
          let time =
                  current.getHours() +
                  ":" +
                  current.getMinutes() +
                  ":" +
                  current.getSeconds() +
                  " " +
                  ampm
          let tips = ""
          let is_cmd = true

          messages.emit("chatMessage", { name, message, time, is_cmd, tips })
        }else {
          let d = JSON.parse(param)
          if(!d || !d.hasOwnProperty("deviceId")) {
            return
          }

          if(this.peers.length < 1){
            return
          }

          if(this.peers[0]?.local !== d.peer) {
            console.log("not me, ignore")
            return
          }

          if(d.device_type == "video") {
            this.state.deviceVideo = d.deviceId
          }else{
            this.state.deviceAudio = d.deviceId
          }
        }
      },
      setName() {
        let name = localStorage.getItem("name")
        if (name) {
          this.name = name
          messages.emit("userInfo", {
            name: name,
          })
        }
      },
      focusChatInput() {
        if (
                !/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)
        ) {
          setTimeout(() => {
            document.getElementById("message-input")?.focus()
          }, 100)
        }
      },
      doDocCenter() {
        messages.emit("switchMode", "doc")
        let urlParams = this.state.urlParams
        let query = []
        for(let [key, value] of urlParams.entries()) {
          //console.log(key, value)
          query.push(key + '=' + value)
        }
        let query_string = query.join('&')
        console.log(query_string)

        messages.emit("loadDoc", 'https://lawdoc.3-3.me/#/ws/list?' + query_string)

        //messages.emit("loadDoc", 'https://lawdoc.3-3.me/#/ws/list?token=' + this.state.token + '&qybh=' + this.state.qybh + '&caseid=' + this.state.caseid + '&tabid=' + this.state.tabid + '&tabname=' + this.state.tabname + '&mxtabid=' + this.state.mxtabid + '&mxtabname=' + this.state.mxtabname + '&mxkeyid=' + this.state.mxkeyid + '&docback=' + this.state.docback + '&num=' + this.state.num)
      },
      async getGeoInfo() {
        await this.$nextTick()
        if(!this.state.client) {
          let name = this.state.uname
          let current = new Date()
          let ampm = current.getHours() < 12 ? "AM" : "PM"
          let time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds() + " " + ampm
          let tips = '获取位置请求'
          let is_cmd = true
          let message = "sys|requestloc|0"
          messages.emit("chatMessage", { name, message, time, is_cmd, tips })
          this.$layer.msg('位置请求已发送')
        }else {
          //this.$layer.msg('正在获取定位...')
          this.$layer.loading({time: 2, content:'正在获取定位...'})
          let geolocation, geo_type = this.state.geotype
          try {
            if ( geo_type === 'baidu' || typeof navigator.geolocation === 'undefined') {
              geolocation = new BMap.Geolocation()
              geo_type = 'baidu'
            } else {
              geolocation = navigator.geolocation
            }
          } catch(e) {console.log(e)}

          //console.log(geo_type, geolocation)
          if(geolocation) {
            geolocation.getCurrentPosition((position) => {
              console.log(position)
              let lat = geo_type === 'baidu' ?  position.point.lat : position.coords.latitude
              let lng = geo_type === 'baidu' ?  position.point.lng : position.coords.longitude
              let point = new BMap.Point(lng, lat)
              var convertor = new BMap.Convertor()
              convertor.translate([point], 1, 5, (data) => {
                if (data.status === 0) {
                  let resultObj = {'point': data.points[0], 'bdlat': lat, 'bdlng': lng}
                  const params = {
                    param: lat + "," + lng,
                  }

                  //if(geo_type === '') {
                  this.$http.get("/aiFlowTest/api/getAddr", {params})
                          .then( response => {
                            console.log(response)
                            //this.$layer.alert(JSON.stringify(response))
                            if (response.result == "succ") {
                              this.state.myGeoInfo = {...resultObj, 'address': response.addr_short}
                              return {...resultObj, 'accident_address': response.addr_short}
                            }else {
                              throw new Error('地址解析失败')
                            }

                          }).then((geoinfo) => {
                    this.sendLocationMsg(geoinfo)
                  }).catch(e => {
                    //console.log(e)
                    this.$layer.closeAll()
                    this.$layer.msg(e.message)
                  })
                } else {
                  //
                }
              })
            }, (err) => {
              console.log(err)
              let msg = ''
              switch(err.code) {
                case err.PERMISSION_DENIED:
                  msg = "您取消了定位"
                  break
                case err.POSITION_UNAVAILABLE:
                  msg = "未获取到位置信息"
                  break
                case err.TIMEOUT:
                  msg = "获取位置信息超时,请开启GPS重试"
                  break
                case err.UNKNOWN_ERROR:
                  msg = "未知错误"
                  break
              }
              this.$layer.closeAll()
              this.$layer.alert(msg)
            }, {
              enableHighAccuracy: false,
              timeout: 5000,
              //maximumAge: 0
            })

          }else {
            this.$layer.closeAll()
            this.$layer.msg('该浏览器不支持获取定位')
          }
        }
      },
      updateGeoinfo(param) {
        return this.$http.post("/updateAiVueData_flowable", param)
                .then( response => {
                  console.log(response)
                  if (response.result == "succ") {
                    this.$layer.msg('位置信息已更新')
                  }
                })
      },
      sendLocationMsg(geoinfo) {
        let name = this.state.uname
        let current = new Date()
        let ampm = current.getHours() < 12 ? "AM" : "PM"
        let time =
                current.getHours() +
                ":" +
                current.getMinutes() +
                ":" +
                current.getSeconds() +
                " " +
                ampm
        let tips = "我的位置: " + geoinfo.accident_address
        let is_cmd = true
        let message = "sys|location|" + JSON.stringify(geoinfo)
        messages.emit("chatMessage", { name, message, time, is_cmd, tips })
        this.$layer.msg('位置信息已发送')
      },
      async initObs() {
        await this.$nextTick()
        let stream_server = this.state.streamserver !== '' ? this.state.streamserver : 'live.3-3.me'
        console.log('stream_server', stream_server)
        this.obs.on('Identified', () => {
          messages.on("ToggleRecord", (start) => {
            this.obs.call('GetStreamStatus').then((ret) => {
              if(ret.outputActive) {
                if (confirm("确定要停止录像吗？\n\n请确认！") === true) {
                  console.log("StopStream")
                  this.state.onAir = false
                  this.obs.call('StopStream')
                }else{
                  console.log("StopStream canceled")
                }

              }else{
                if(this.state.autoRecord || (confirm("确定要开始录像吗？\n\n请确认！") === true) ) {
                  let current = new Date()
                  let stream_name = current.getFullYear() + "" + (current.getMonth() + 1) + "" + current.getDate() +
                          current.getHours() + "" + current.getMinutes() + "" + current.getSeconds() + ""
                  let tabid = this.state.tabid ?? ""
                  let caseid = this.state.caseid ?? localStorage.getItem("caseid")

                  if (caseid) {
                    stream_name = tabid + '' + caseid
                  }

                  this.obs.callBatch([
                    {
                      requestType: 'SetStreamServiceSettings',
                      requestData: {
                        streamServiceType: 'rtmp_custom',
                        streamServiceSettings: {
                          server: 'rtmp://' + stream_server + '/case/' + stream_name,
                          key: '',
                        }
                      },
                    },
                    {
                      requestType: 'Sleep',
                      requestData: {
                        sleepMillis: 2000,
                        //sleepFrames: 30,
                      },
                    },
                    {
                      requestType: 'StartStream'
                    },
                  ], {
                    executionType: 0,
                    haltOnFailure: true
                  }).then((results) => {
                    console.log("==obs.callBatch==then==",results)
                    this.state.onAir = true
                  }).catch((e) => {
                    alert("录像失败，禁用文书制作！")
                    console.log("=====obs.callBatch===e==",e)
                  })


                }else{
                  console.log("StartStream canceled")
                }


              }
            }).catch((error) => {
              this.state.onAir = false
              console.log(error)
            })

          })

        })

        this.obs.connect('ws://127.0.0.1:4455').catch((error) => {
          this.state.onAir = false
          this.$layer.alert('OBS服务无法连接,请打开录像程序OBS', {title: '提示'})
          console.log(error)
        })

      },
      async initWidth() {
        await this.$nextTick()
        if(this.state.width !== '') {
          this.$refs.docContainer.$el.style.width = this.state.isPC ? this.state.width : "auto"
          this.$refs.ocrContainer.$el.style.width = this.state.isPC ? this.state.width : "auto"
          this.$refs.pageContainer.$el.style.width = this.state.isPC ? this.state.width : "auto"
          this.$refs.chatContainer.$el.style.width = this.state.isPC ? this.state.width : "auto"
        }else {
          this.$refs.docContainer.$el.style.width = this.state.isPC ? "clamp(25rem, 50%, 75%)" : "auto"
          this.$refs.ocrContainer.$el.style.width = this.state.isPC ? "clamp(25rem, 50%, 75%)" : "auto"
          this.$refs.pageContainer.$el.style.width = this.state.isPC ? "clamp(25rem, 50%, 75%)" : "auto"
          this.$refs.chatContainer.$el.style.width = this.state.isPC ? "clamp(25rem, 50%, 75%)" : "auto"
        }
      },
      confirmContinue() {
        let timer_id = setTimeout(() => {
          this.$layer.closeAll()
          this.continueRecord = 'stop'
        }, 6e4)

        this.$layer.alert('是否继续录像?', {
                  title: '提示'
                }, layerid => {
                  clearTimeout(timer_id)
                  this.$layer.close(layerid)
                  this.continueRecord = 'continue'
                }
        )


      },
      handleUnload(evt) {
        // let data = {
        //     'dvs': document.visibilityState,
        //     'evt': evt
        // }

        // console.log(data)

        //navigator.sendBeacon('//127.0.0.1:4466', JSON.stringify(data))
      },
      initHeartbeat() {
        this.heartbeatTimer && clearInterval(this.heartbeatTimer)
        this.heartbeatWs = null
        if('WebSocket' in window) {
          this.heartbeatWs = new WebSocket('ws://127.0.0.1:5544')
          this.heartbeatWs.onopen = ()=> {
            this.heartbeatTimer = setInterval(() => {
              this.heartbeatWs?.readyState === 1 && this.heartbeatWs.send('ping')
            }, 1e4)
          }

          this.heartbeatWs.onmessage = (e)=> {
            console.log(e.data)
          }

          this.heartbeatWs.onclose = (e)=> {
            setTimeout(this.initHeartbeat, 3e3)
          }

          this.heartbeatWs.onerror = (e)=> {
            //setTimeout(this.initHeartbeat, 3e3)
          }

        }
      },
      startTimeout() {
            // 在1.5小时后调用 confirmDialog 函数
           this.timer = setTimeout(this.confirmDialog, this.timeout);
        },
        confirmDialog() {
        let _this=this;
             clearTimeout(this.timer);
             _this.timer1= setTimeout(this.closePage, 10000);
            this.$layer.confirm('已经运行1小时，继续使用请点确定？如取消和不操作，10秒后关闭页面。', {
                  title: '提示'
                }, layerid => {
                   console.log("==click  了=")
                   // 用户点击了“确定”，重置计时器
                   clearTimeout(_this.timer1);
                   _this.startTimeout();
                   _this.$layer.close(layerid)
                }
             )

        },closePage() {
          console.log("====close page==");
          //  window.close(); // 关闭当前窗口
             window.location.href = '/'; // 导航到另一个页面
        }

    },
    mounted() {
      this.setName()
      this.triggerChatFunctions()

      setTimeout(async () => {
        this.conn = await setup()
      }, 50)
      if (!this.hasPeers && !window.iPhone && this.state.showInviteOnStart) {
        this.mode = "share"
      }
      this.fullscreenHandler = (ev) => {
        this.isFullScreen = !!document.fullscreenElement
      }
      document.addEventListener("fullscreenchange", this.fullscreenHandler)

      this.handleIframeMessage = (evt) => {
        const data = evt.data
        //console.log(data)
        if(typeof data !== 'string') {
          return
        }
        let name = this.name
        let current = new Date()
        let ampm = current.getHours() < 12 ? "AM" : "PM"
        let time =
                current.getHours() +
                ":" +
                current.getMinutes() +
                ":" +
                current.getSeconds() +
                " " +
                ampm
        let tips = ""
        let is_cmd = data?.startsWith('sys|')
        if(is_cmd) {
          //this.processSysCommand(name, data, time)
          let cmd = data?.split('|')
          let op = cmd[1], param = cmd[2]
          //console.log("op=" + op, "param=" + param)
          switch(op) {
            case "mode":
              tips = ""
              break
            case "doc":
              tips = "点此查看文书"
              break
            case "tips":
              tips = ""
              break
            default:
              tips = "未知指令: " + op
              break
          }

        }

        messages.emit("chatMessage", { name, message: data, time, is_cmd, tips })
      }
      window.addEventListener('message', this.handleIframeMessage)
      //if(!this.state.isPC) { this.getGeoInfo() }
      if(this.state.isPC && !this.state.client) {
        if(this.state.recordType === "obs") {
          this.initObs()
          setTimeout(() => {
            messages.emit("ToggleRecord", 1)
          }, 2000)

          setTimeout(() => {
            this.confirmContinue()
          }, 54e5)

          this.initHeartbeat()
        }

        ;;
        ["visibilitychange", "pagehide", "beforeunload", "unload"].forEach(
                (t) => {
                  window.addEventListener(t, this.handleUnload, {capture: true})
                }
        )
      }
      if(this.state.isPC) {messages.emit('switchMode', 'doc')}

      if(this.state.isPC && !this.state.client && this.state.autoRecord && this.state.recordType === "webrtc") {
        const video_container = document.getElementById('video-container-true')
        this.state.videoWallCanvas = document.createElement('canvas')
        // this.state.videoWallCanvas.width = video_container.offsetWidth || 1920
        // this.state.videoWallCanvas.height = video_container.offsetHeight || 1080

         this.state.videoWallCanvas.width =   1920
          this.state.videoWallCanvas.height =   1080


        console.log("=== videoWallCanvas created ===", this.state.videoWallCanvas)

        // document.body.appendChild(this.state.videoWallCanvas)
        this.state.audioContext = new window.AudioContext()
        this.state.audioDestination = this.state.audioContext.createMediaStreamDestination()
      }
          this.startTimeout();

    },
    beforeDestroy() {
      document.removeEventListener("fullscreenchange", this.fullscreenHandler)
      messages.emit("releaseAVsource")
      this.conn?.cleanup()
      //this.obs?.call('StopStream')
    },
    created() {
      this.state.muteVideo = this.state.bystander
      this.state.muteAudio = this.state.bystander
      //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作
      if(!this.state.isPC) {
        history.pushState(null, null, window.location.href)
        window.addEventListener("popstate", () => {
          history.pushState(null, null, window.location.href)
          if(!this.state.isPC) this.mode = ''
        })
      }
    },
    watch: {
      continueRecord(value) {
        console.log("continueRecord", value)
        if(value === 'stop') {
          this.state.onAir = false
          this.obs?.call('StopStream')
          this.$layer.msg('录像已停止')
        }
      },
      "state.remoteDeviceVideo"() {
        this.setUserDevice("video")
      },
      "state.remoteDeviceAudio"() {
        this.setUserDevice("audio")
      },
    }
  }
</script>
